import * as React from 'react';

// Lets the active tab show a status ("● live · plan 4 min ago", "● sensors 2 min ago") in the App header.
export const HeaderStatusContext = React.createContext<(status: React.ReactNode) => void>(() => undefined);

export function useHeaderStatus(status: React.ReactNode): void {
  const setStatus = React.useContext(HeaderStatusContext);
  React.useEffect(() => setStatus(status), [setStatus, status]);
  React.useEffect(() => () => setStatus(null), [setStatus]);
}
